import {LauncherServiceBase} from '../launcher-service-base';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {action, computed, observable} from 'mobx';
import {Check} from '@sparkware/app-utils';
import {ISdmService, SdmGamesMap} from './sdm.service.interface';
import {SdmGame} from './sdm-game';

export class SdmService extends LauncherServiceBase implements ISdmService {
    constructor(services: ILauncherServiceFactory) {
        super(services);

        this.reaction(
            () => {
                return {
                    brandId: this.services.configurationsAreas.sdk.Skin.brandID.getValue(),
                    sdkApiOrigin: this.services.configurationsAreas.sdk.api.getValue(),
                    country: this.services.configurationsAreas.orbit.country.getValue()
                }
            },
            (data) => {
                this._updateAvailableGames(data.sdkApiOrigin, data.brandId, data.country)
            },
            {
                fireImmediately: true
            });
    }

    @observable.ref
    gamesInfo: SdmGamesMap = {};

    @action.bound
    private _setGamesInfo(gamesInfo: SdmGamesMap): void {
        this.gamesInfo = gamesInfo
    }


    private async _updateAvailableGames(sdkApiOrigin: string, brandId: number, country: string): Promise<void> {

        sdkApiOrigin = sdkApiOrigin || window.location.origin;
        brandId = Check.isNullOrUndefined(brandId) ? 0 : brandId;

        let response = null;

        try {
            //TODO - switch to cgpapi/orbitLauncher/getAllSdmGames?brandId
            response = await this.services.http.get(`${sdkApiOrigin}/orbit/launcher/getAllSdmGames?brandId=${brandId}&country=${country}`);
        } catch (err) {
            this.services.logger.error(`Failed to read SDM games list from ${sdkApiOrigin}`, err);
            response = await this.services.http.get(`https://mirage-cgp-latest-eu.888casino.com/orbit/launcher/getAllSdmGames?brandId=${brandId}&country=${country}`);
        }

        let gamesMap: SdmGamesMap = {};

        if(response?.Games) {
            response.Games.forEach(gameInfo => {
                gamesMap[gameInfo.GameType] = new SdmGame(gameInfo);
            });
        }

        this._setGamesInfo(gamesMap);
    }

    findGamesByText(searchText: string): SdmGame[] {
        let result: SdmGame[] = [];
        let searchWordsRegExp = searchText.split(' ')
            .map(word => word.trim())
            .filter(word => !Check.isEmpty(word))
            .map(word => new RegExp(word, 'gi'));

        Object.values(this.gamesInfo).forEach(gameInfo => {
            if(gameInfo.isAllWordsMatch(searchWordsRegExp)) {
                result.push(gameInfo)
            }
        });

        return result;
    }

    @computed
    get allGames(): SdmGame[] {
        return Object.values(this.gamesInfo);
    }

    @computed
    get companies(): string[] {
        return [...new Set(this.allGames.map(game => game.companyName))].sort((v1, v2) => v1.localeCompare(v2));
    }

    @computed
    get vendors(): string[] {
        return [...new Set(this.allGames.map(game => game.vendorName))].sort((v1, v2) => v1.localeCompare(v2));
    }

}